
/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/forwardcommandunits.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/gensetstatus.cs.d.ts" />
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import ReeferCallout from '../../actions/ReeferCallout';
import 'ag-grid-enterprise';
import { RCUtils } from './../../RCUtils';
import { GensetHistoryGrid } from './GensetHistoryGrid';
import Formatters from '../../actions/Formatters';
import { GensetCellRender } from '../../actions/GensetCellRender';
import GensetFormatters from '../../actions/GensetFormatter';
import * as Exceljs from '../../actions/ExportToExcel.js';
import $ from 'jquery';
import uniq from 'lodash/uniq';
// pull in the ag-grid styles we're interested in
import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import '../../../node_modules/react-toggle-switch/dist/css/switch.min.css';
import { EmailControlExcel } from './../sharedcomponents/EmailControlExcel';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { GridGensetStatusToolBar } from '../sharedcomponents/GridGensetStatusToolBar';
//import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import { GridColumnPreferences } from './../sharedcomponents/GridColumnPreferences';
import { GensetToggleButtonsFilter } from '../childcomponents/GensetToggleButtonsFilter';
import { GensetPingControl } from './../sharedcomponents/ForwardCommands/GensetCommands/GensetPingControl';
import UserRights from '../../actions/UserRights';
import { AssignToCustomer } from '../childcomponents/AssignToCustomer';
import { UnassignReefersFromCustomer } from '../childcomponents/UnassignReefersFromCustomer';
import { ExportToExcelConfirmationWindow } from '../sharedcomponents/ExportToExcelConfirmationWindow';
import { EmailControlExcelPreference } from '../sharedcomponents/EmailControlExcelPreference';
import forEach from 'lodash/forEach';
var Config: any = require('../../Config.json');
var Excel = Exceljs.default;

interface GensetGridState {
    loading: boolean;
    Filters: server.ReeferSearchFilters;
    rowData: any[];
    columnDefs: any[];
    selectedItems: any[];
    overlayLoadingTemplate: any;
    modelTitle: string;
    popUpHtml: any;
    isChangeDeforstInterval: boolean;
    pretripCmd: string;    
    reeferFormatter: server.ReeferFormatter[];
    pageSize: any;
    gridApiParams: any;
    tempFilters: server.ReeferSearchFilters;
    exportFields: ExportFields;    
    CustomAttributes: server.CustomAttributes[];
    defaultColDef: any[];
    rowGroupPanelShow: string;
    groupDefaultExpanded: number;
    autoGroupColumnDef: any;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

class ExportFields {
    ExportData: string;
}

var currentMousePos = { x: -1, y: -1 };
var self;
var selectedRowData;
var coppiedData;
var coppiedDataWithHeader;
var customerTypeCd;
var functionId;
var customerAccessData: any[];
var columnDefs2: any[];
var columnDefs: any[];
var commandIssued: boolean = false;
var gensetAssetSensors: any[];
var selectedRowIndex: number;
var IsTriggered: boolean;

export class GensetStatusGrid extends React.Component<any, GensetGridState> {
    constructor(props: any) {
        super(props);
        customerAccessData = [];
        selectedRowIndex = -1;
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        //customerTypeCd = props.loggedInUserData.User.Customer.CustomerTypeCd;
        // new FilterDto();
        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        var exportData = new ExportFields();
        functionId = 46; // functionId for GensetStatus Grid        
        this.state = {
            loading: true, 
            Filters: this.props.statusFilter, 
            rowData: this.props.propsGensetData, 
            columnDefs: [], 
            selectedItems: [], 
            overlayLoadingTemplate: overlayTemplate, 
            modelTitle: '', 
            popUpHtml: '', 
            isChangeDeforstInterval: false, 
            pretripCmd: null, 
            reeferFormatter: [], //this.props.propsReeferFormatterData, 
            tempFilters: null, 
            pageSize: 25, 
            gridApiParams: [], 
            exportFields: exportData, 
            defaultColDef: [],
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: -1,
            IsCommandIssued: false,
            PrevSelectedItems: [],
            autoGroupColumnDef: { minWidth: 200 },
            CustomAttributes: []
        };
      
        self = this;
    }   

    componentWillReceiveProps(nextprops: any) {        
        const propsGensetData: any = this.props.propsGensetData;
        if (propsGensetData !== nextprops.propsGensetData)
            this.setState({ rowData: [] });

        /*WI-24005 - as custom attributes are not for genset
        if (JSON.parse(sessionStorage.getItem('UserInfo')).IsCustomAttributesEnable) {
            var newColumns = self.createColumnDefs();
            var generatedColumns = [];
            if (nextprops.CustomAttributes != null && nextprops.CustomAttributes != undefined && nextprops.CustomAttributes.length > 0) {
                $.each(nextprops.CustomAttributes, function (i, val) {
                    var customAttributeObject = { headerName: '', field: '', cellRenderer: Formatters.stringTypeFormatter, width: 130, onCellClicked: self.onCellClickedCopy.bind(this) };
                    var attributeName = val.AttributeName;
                    var columnHeaderName = attributeName.replace(' ', '');
                    customAttributeObject.headerName = attributeName;
                    customAttributeObject.field = columnHeaderName;
                    generatedColumns.push(customAttributeObject);
                });

                var newColumnDefination = {
                    headerName: "Asset Attributes",
                    children: generatedColumns
                };

                newColumns.push(newColumnDefination);
                this.setState({ columnDefs: newColumns, CustomAttributes: nextprops.CustomAttributes });
            }            
        }
        else {*/
        //var columnDefinitions = self.createColumnDefs();
        //this.setState({ columnDefs: columnDefinitions });
        //this.renderCustomerDeviceTypeSensorColumns(); // Commented for fixing WI 26094
        //}

        if (nextprops.propsGensetData != null && nextprops.propsGensetData != undefined && nextprops.propsGensetData.length > 0 && nextprops.statusFilter.StatusFilters != undefined
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.DryInGeofence && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.DryOutGeofence
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.AllReefer && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.Running
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.Stopped && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.MissedRunning
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.MissedStopped && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.AllMicroAlaram
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.MASevere && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.MAMinor
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.AllCargoCare && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.CCSevere
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.CCMinor && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.CCInformational
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.ChassisPwrInGeofence && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.ChassisPwrOutGeofence
            && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.ChassisNotPwrInGeofence && nextprops.statusFilter.StatusFilters[0] != ReeferAndDryAndChassisStatusEnum.ChassisNotPwrOutGeofence) {
            this.setState({ rowData: nextprops.propsGensetData });

            if (self.state.ToggleSearchParams != null && self.state.ToggleSearchParams != undefined) {
                self.filterGensetStatusGrid(self.state.ToggleSearchParams);
            }
        }        
    }

    renderCustomerDeviceTypeSensorColumns() {
        columnDefs = this.createColumnDefs();
        var newColumns = columnDefs;
        //columnDefs2 = columnDefs;
        var generatedColumns = [];
        gensetAssetSensors = this.props.customerDeviceTypeSensor.filter(x => x.AssetTypeCd == 'G');
        if (gensetAssetSensors != null && gensetAssetSensors != undefined && gensetAssetSensors.length > 0) {
            $.each(gensetAssetSensors, function (i, val) {
                var customerDeviceTypeSensorObject: any;
                if (val.SensorTypeCd.trim() == "T")
                    customerDeviceTypeSensorObject = { headerName: '', field: '', enableRowGroup: true, headerClass: val.OORText, sortable: true, resizable: true, headerValueGetter: Formatters.TempSensorHeaderFormatter, valueGetter: Formatters.stringTypeSortingForSensorfields, cellRenderer: Formatters.TemperatureSensorValueFormatter, width: 130, onCellClicked: self.onCellClickedCopy.bind(this) };
                else
                    customerDeviceTypeSensorObject = { headerName: '', field: '', refData: val.SensorSetDsc + "," + val.SensorResetDsc, enableRowGroup: true, headerClass: val.OORText, sortable: true, resizable: true, valueGetter: Formatters.stringTypeSortingForDigitalSensorfields, cellRenderer: Formatters.DigitalSensorFormatter, width: 130, onCellClicked: self.onCellClickedCopy.bind(this) };

                //var fieldName = val.FieldValue;
                var columnHeaderName = val.ColumnNm;
                var columnFieldName = val.FieldName + "_" + val.DeviceTypeCd.trim();
                customerDeviceTypeSensorObject.headerName = columnHeaderName;
                customerDeviceTypeSensorObject.field = columnFieldName;
                generatedColumns.push(customerDeviceTypeSensorObject);
            });

            var newColumnDefination = {
                headerName: "Device Sensor(s)",
                children: generatedColumns
            };
            if (!newColumns.some(x => x.headerName === "Device Sensor(s)"))
                newColumns.push(newColumnDefination);
            this.setState({ columnDefs: newColumns });

            if (!columnDefs2.some(x => x.headerName === "Device Sensor(s)"))
                columnDefs2.push(newColumnDefination);// = newColumns;
        }
        else {
            this.setState({ columnDefs: columnDefs });
        }
    }

    componentDidMount() {
        //var columnDefs = this.createColumnDefs();
        columnDefs2 = this.createColumnDefs();
        //this.setState({ columnDefs: columnDefs });
        setTimeout(() => {
            this.renderCustomerDeviceTypeSensorColumns();
        }, 1000);

       //var functionID = 1;
       // var url = Config.ApiBaseUrl + '/api/User/GetDefaultSearchParams?FunctionId=' + functionID;
       // var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
       // fetch(request)
       //     .then(RCUtils.handleError)
       //     .then(response => response.json() as Promise<server.UserPreferenceData>)
       //     .then(data => { 
       //         if (data != null && data != undefined) {
       //             if (!data.DefaultSearch)
       //                 this.props.requestGensetAdvanceSearch(this.state.Filters);
       //         }
       //         else
       //             this.props.requestGensetAdvanceSearch(this.state.Filters);
       //     });       
        self.setState({ tempFilters: this.state.Filters });
        $('.ag-column-hover').contextmenu(function (e) {
            var relX = e.pageX - $('.ag-column-hover').offset().left;
            var relY = (e.pageY - $('.ag-column-hover').offset().top);
            $(".gensetcontext-menu").toggle(100).css({
                top: relY,
                left: relX
            });
            $("#gensetcontextmenu").hide();
            $(".gensetcontext-menu").hide();
            e.preventDefault();
        });
       
       
        
        
        $(document).mousemove(function (event) {
            currentMousePos.x = event.pageX;
            currentMousePos.y = event.pageY;
            event.preventDefault();
        });
        Excel.draggableModalPopup(document.getElementById("contextMenuModel"));
    }

    onRefreshData = () => {
        $('#globalLoader').show();
        this.setState({
            rowData: this.state.rowData
        });

        if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != [] && self.state.gridApiParams.length > 0) {
            self.state.gridApiParams.paginationGoToFirstPage();
        }
        
        $('#globalLoader').hide();
    };

    columnRowGroupChanged(params: any) {
        self.clearGridRowSelection(params);
    }

    /* WI 26971 implementation  start */
    static validateGensetStatusHistoryMismatch(statusEventDttm: any, historyEventDttm: any) {
        IsTriggered = false;
        if (statusEventDttm != historyEventDttm)
            RCNGWindow.ConfirmWindow.showConfirmBox("New events are available for the Genset Status grid. Refresh now?", self.onRefreshGensetStatusGrid.bind(this), self.onCancelRefreshGensetStatusGrid.bind(this));
    }

    onCancelRefreshGensetStatusGrid() {
        RCNGWindow.ConfirmWindow.close();
    }

    onRefreshGensetStatusGrid() {
        if (!IsTriggered) {
            IsTriggered = true;
            RCNGWindow.ConfirmWindow.close();
            self.refreshGensetStatusGridForNewEvents();
        }
    }

    refreshGensetStatusGridForNewEvents() {
        selectedRowIndex = -1;
        this.setState({
            selectedItems: [],
            isChangeDeforstInterval: false,
            pretripCmd: null,
            modelTitle: '',
            popUpHtml: ''
        }, () => this.GensetSearchFilter(self.props.statusFilter, true, false));

    }
  /* WI 26971 implementation  end */
    
    onRowDataChanged(params: any): void {
        var gensetIdSelected = "";
        if (self.state.IsCommandIssued && self.state.PrevSelectedItems.length > 0) {
            //var selItems = self.state.PrevSelectedItems;
            gensetIdSelected = self.state.PrevSelectedItems[0].GensetCurrentConditionId;
            // gensetIdSelected = "TEST0000540";
        }
        commandIssued = false;
        var TotalCount = 0;
        var PageSize = self.state.pageSize;
        var TempCount = 0;
        var gridData = self.state.rowData;
        if (gridData != null && gridData != undefined && gridData.length > 0) {
            TotalCount = gridData.length;
            params.api.setFunctionsReadOnly(false);
        } else {
            params.api.setFunctionsReadOnly(true);
        }
        if (TotalCount > 0 && gensetIdSelected !== "") {
            let count = 0;
            if (gensetIdSelected) {
                commandIssued = true;
                params.api.forEachLeafNode((node) => {
                    count = count + 1;
                    if (node.data.GensetCurrentConditionId === gensetIdSelected) {
                        TempCount = count;
                        var pageNo = Math.ceil((TempCount / PageSize));
                        var setPageNum = pageNo - 1;
                        //console.log('pageNo' + pageNo);
                        params.api.paginationGoToPage(setPageNum);
                        var currentParent = node.parent;
                        while (currentParent) {
                            currentParent.setExpanded(true);
                            currentParent = currentParent.parent;
                        }
                        node.setExpanded(true);
                        node.setSelected(true);
                        self.setState({ IsCommandIssued: false });
                        return;
                    }
                })
            }
        }
    }

    UpdateIsCommandIssued(IsCmdIssued: any) {
        self.setState({ IsCommandIssued: IsCmdIssued });
    }
    UpdatePrevSelectedItems(prevSelectedItems: any) {
        self.setState({ PrevSelectedItems: prevSelectedItems });
    }

    static ClearGensetStatusGridData() { 
        if (self != undefined) {
            //ReeferCallout.ResetMapPushpins();
            selectedRowIndex = -1;
            self.setState({
                rowData: [],
                loading: false
            });

            if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != [] && self.state.gridApiParams.length > 0) {   
                if (typeof self.state.gridApiParams.paginationGoToFirstPage() != "undefined")
                    self.state.gridApiParams.paginationGoToFirstPage();
            }
        }
    }


    gensetContextMenuClick(this: any, item: any) {
        switch (item) {
            case "Map": this.gensetmapAction(this.state.selectedItems);
                break;
            case "History": this.gensethistoryAction(this.state.selectedItems);
                break;
             case "CommandStatus": this.gensetcommandstatusAction(this.state.selectedItems);
                break;
             case "Details": this.gensetdetailsAction(this.state.selectedItems, 'Genset','CurrentDetails');
                break;
            case "Copy": this.gensetdetailsCopyAction();
                break;

        }
    }

    gensetdetailsCopyAction() {
        var result = this.copyToClipboard(coppiedData);
    }

    gensetdetailsCopyWithHeaderAction() {
        var result = this.copyToClipboard(coppiedDataWithHeader);
    }    
	
	copyToClipboard(text) {
        if ((window as any).clipboardData && (window as any).clipboardData.setData) {
            return (window as any).clipboardData.setData("Text", text);
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }

    onCellClickedCopy(event) {
        //coppiedDataWithHeader = event.colDef.headerName + " \r\n" + event.value;
        //coppiedData = event.value;
        var isHistoryCall = false;

        if (selectedRowIndex != event.rowIndex) {
            selectedRowIndex = event.rowIndex;
            isHistoryCall = true;
        }

        if (event.data != null && event.data != undefined) {
            self.props.getLastSelectedRow(event.data);
            //$('#globalLoader').show();
            if (event.colDef.headerName === "Comments" && event.value === "0")
                this.gensetdetailsAction(this.state.selectedItems, 'Genset','Comments');
            else if (isHistoryCall) 
                GensetHistoryGrid.ApplyGensetHistorySearch(event.data, false, self.props.gensetHistoryEnabled);
        }
    }

    gensetdetailsAction(data: any, dataSource: any, isOpenVia:any) {
        var gensetdetails = data;
        this.props.gensetdetailsAction(gensetdetails, dataSource, isOpenVia);
    }

    gensethistoryAction(data: any) {
        var gensetdetails = data;
        this.props.gensethistoryAction(gensetdetails);
    }

    gensetmapAction(data: any) {
        var gensetdetails = data;
        this.props.gensetMapAction(gensetdetails);
    }

    gensetcommandstatusAction(data: any) {
        var gensetdetails = data;
        this.props.gensetcommandstatusAction(gensetdetails);
    }


    static SelectCurrentGenset(currentGenset: any) {
        self.state.gridApiParams.deselectAll();
        GensetHistoryGrid.ClearHistoryGridData();
        var countRecordPerPage = 0;
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode(function (node) {
            countRecordPerPage = countRecordPerPage + 1;
            if (node.data.AssetNumber === currentGenset.AssetNumber) {
                var currentPage = Math.trunc(countRecordPerPage / self.state.gridApiParams.paginationProxy.pageSize);
                if (currentPage > 1) {
                    self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.paginationGoToPage(currentPage);
                }

                node.setSelected(true);
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.ensureIndexVisible(node.rowIndex);
                self.setState({ selectedItems: node.data });
                self.props.getLastSelectedRow(node.data);
                //$('#globalLoader').show();
                GensetHistoryGrid.ApplyGensetHistorySearch(node.data, true, self.props.gensetHistoryEnabled);
            }
        });
    }

    static SelectCurrentNode(currentGensetId: string) {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode(function (node) {
            if (node.data.AssetNumber === currentGensetId) {
                node.setSelected(true);
            }
        });
    }
    
    static ApplyGensetSearchFilter(filters: server.ReeferSearchFilters, eventsRefresh: boolean) { 
            self.GensetSearchFilter(filters, eventsRefresh, true);
    }

    GensetSearchFilter(filters: server.ReeferSearchFilters, eventsRefresh: boolean, newSearch: boolean) {         
        if (self != undefined) {
            $('#globalLoader').show();
           if (self.state.gridApiParams != null && self.state.gridApiParams != undefined) {
               if (typeof self.state.gridApiParams.showLoadingOverlay !== "undefined") {
                   //self.state.gridApiParams.showLoadingOverlay();
                   //self.state.gridApiParams.paginationGoToFirstPage();
                   //self.state.gridApiParams.deselectAll();
               }
            }
            
            if (filters != null && filters != undefined) {
                  var customAttributesInfo = {};
                var filterset: server.ReeferSearchFilters = {
                    SelectedOem: null, SelectedCountry: null, SelectedGeofence: null, SelectedGeofenceInside: null, SelectedInterval: null, SelectedReefer: null, SelectedAssetStates: null, 
                    SelectedVesselCode: null, StatusFilters: [], AllReefers: null, CustomAttributeFilters: customAttributesInfo, SelectedAssetTypes: null, SelectedBookingNumber: null, SelectedVesselCD: null,
                    SelectedVoyage: null, SelectedCall: null, SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', SelectedCTProfileIds: []  //WI-26881
                };
                         
                filterset.SelectedCountry = (filters.SelectedCountry == "" || filters.SelectedCountry == undefined) ? null : filters.SelectedCountry;
                filterset.SelectedGeofence = (filters.SelectedGeofence == "" || filters.SelectedGeofence == undefined) ? null : filters.SelectedGeofence;
                filterset.SelectedGeofenceInside = (filters.SelectedGeofenceInside == "" || filters.SelectedGeofenceInside == undefined) ? null : filters.SelectedGeofenceInside;
                filterset.SelectedInterval = (filters.SelectedInterval == "" || filters.SelectedInterval == undefined) ? null : filters.SelectedInterval;
                filterset.SelectedAssetTypes = (filters.SelectedAssetTypes == "" || filters.SelectedAssetTypes == undefined) ? null : filters.SelectedAssetTypes;
                filterset.SelectedAssetStates = (filters.SelectedAssetStates == "" || filters.SelectedAssetStates == undefined) ? null : filters.SelectedAssetStates;
                filterset.SelectedOem = (filters.SelectedOem == "" || filters.SelectedOem == undefined) ? null : filters.SelectedOem;
                filterset.SelectedReefer = (filters.SelectedReefer == "" || filters.SelectedReefer == undefined) ? null : filters.SelectedReefer;
                filterset.AllReefers = (filters.AllReefers == "" || filters.AllReefers == undefined) ? null : filters.AllReefers;
                filterset.SelectedVesselCode = (filters.SelectedVesselCode == "" || filters.SelectedVesselCode == undefined) ? null : filters.SelectedVesselCode;
                filterset.SelectedVesselCD = (filters.SelectedVesselCD == "" || filters.SelectedVesselCD == undefined) ? null : filters.SelectedVesselCD;//WI-26881
                filterset.SelectedVoyage = (filters.SelectedVoyage == "" || filters.SelectedVoyage == undefined) ? null : filters.SelectedVoyage//WI-26881
                filterset.SelectedCall = (filters.SelectedCall == "" || filters.SelectedCall == undefined) ? null : filters.SelectedCall;//WI-26881
                filterset.StatusFilters = filters.StatusFilters;
                filterset.CustomAttributeFilters = filters.CustomAttributeFilters;
                self.setState({
                    tempFilters: filterset
                });
                
                var resultSet = self.props.requestGensetAdvanceSearch(filterset, eventsRefresh, newSearch,true);

            }
        }
    }
   
    onGridReady(params: any) {
        //this.gridApi.sizeColumnsToFit();
        self.setState({ gridApiParams: params.api });
       // params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        var gridPreferencesData: any = self.props.dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 12);
        var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        //GridPreferenceControl.StatusGridPreferenceColumns(functionId, params.api, "GensetGrid");
        setTimeout(() => {
            GridColumnPreferences.StatusGridPreferenceColumns(functionId, params.api, gridPreferencesData, "GensetStatusGrid");
        }, 3000); 
    }

    static refreshGridReady(dashboardWidgetsSearch: any){
        var gridPreferencesData: any = dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 12);
        var defaultColumns = self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        setTimeout(() => {
            GridColumnPreferences.StatusGridPreferenceColumns(functionId, self.state.gridApiParams, gridPreferencesData, "GensetStatusGrid");
        }, 500);       
    }

    static ClearSelection() {
        $('#globalLoader').show();
        selectedRowIndex = -1;
        //GensetHistoryGrid.ClearHistoryGridData();
        //this.props.clearGridHeaderExtension();
        if (self != undefined) {
            self.state.gridApiParams.deselectAll();
        }
        //ReeferCallout.BindClusterMapPushpins(this.state.rowData, 'genset', self.state.reeferFormatter);
        $('#globalLoader').hide();
    }

    onGridPaginationChanged(params: any) {
        if (params.newPage) {
            self.props.clearGridHeaderExtension();
            if (!commandIssued)
            params.api.deselectAll();
            commandIssued = false;
            GensetHistoryGrid.ClearHistoryGridData();
            //ReeferCallout.BindClusterMapPushpins(this.state.rowData, 'genset');
        }

        //if (params.api.getDisplayedRowCount() == 1) {
        //    var rowindex = 0;
        //    var rowNode = params.api.getRowNode(rowindex);
        //    // do something with the row, eg select it
        //    if (rowNode != undefined && rowNode != null) {
        //        rowNode.setSelected(true);
        //        GensetHistoryGrid.ApplyGensetHistorySearch(rowNode.data, false);
        //    }
        //}
    }

    italicizeGridRows(params: any) {
        if (params.data != null && params.data != undefined) {
            if (params.data.EventDTTM != params.data.DeviceDataTime)
             return { 'font-style': 'italic' }
        }
    }
    onSort(params: any) {
        params.api.clearFocusedCell();
        this.clearGridRowSelection(params);
    }
    onGridSelectionChanged(params: any) {
        $("#gensetcontextmenu").show();
        var selectedGensetData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length != 0) {
            //var selected = params.api.getFocusedCell();
            //var selectedRow = params.api.getRowNode(selected.rowIndex);
            //ReeferCallout.ResetMapPushpins(); // Clear existing pushpins
            selectedRows.forEach(function (selectedRow, index) {
                selectedGensetData.push(selectedRow);
                //ReeferHistoryGrid.ApplyReeferHistorySearch(selectedRow);
            });
            //var selectedItems = self.state.selectedItems;
            self.setState({
                selectedItems: selectedGensetData,
                isChangeDeforstInterval: false,
                pretripCmd: null,
                modelTitle: '',
                popUpHtml: ''
            });
            self.props.getSelectedRow(selectedRows);
            //self.props.getLastSelectedRow(selectedRow.data);
            //$('#globalLoader').show();
            //ReeferHistoryGrid.ApplyReeferHistorySearch(selectedRow.data);
            //$("#gensetcontextmenu").show();
            //if (selectedGensetData.length > 1) {
            //    $('#liDetailsRequiresRight').removeClass('enabled');
            //    $('#liDetailsRequiresRight').addClass('disabled');
                //if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').removeClass('enabled');
                //if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').addClass('disabled');
            //}
            //else {
            //    $('#liDetailsRequiresRight').removeClass('disabled');
            //    $('#liDetailsRequiresRight').addClass('enabled');
                //if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').removeClass('disabled');
                //if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').addClass('enabled');
            //}
            //var forwardCommandParam = JSON.stringify(selectedGensetData);
            //var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetAssetAssigned3rdParty';
            //var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParam, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            //fetch(request)
            //    .then(RCUtils.handleError)
            //    .then(response => response.json() as Promise<string>)
            //    .then(data => {
            //        if (data == "assigned") {
            //            if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').removeClass('disabled');
            //            if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').addClass('enabled');
            //            if ($("#liUnassignFromCustomerRequiresRight").hasClass("show")) $('#liUnassignFromCustomerRequiresRight').removeClass('disabled');
            //            if ($("#liUnassignFromCustomerRequiresRight").hasClass("show")) $('#liUnassignFromCustomerRequiresRight').addClass('enabled');
            //            if ($("#liAssignToCustomerRequiresRight").hasClass("show")) $('#liAssignToCustomerRequiresRight').removeClass('enabled');
            //            if ($("#liAssignToCustomerRequiresRight").hasClass("show")) $('#liAssignToCustomerRequiresRight').addClass('disabled');

            //        }
            //        else if (data == "unassigned") {
            //            if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').removeClass('disabled');
            //            if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').addClass('enabled');
            //            if ($("#liUnassignFromCustomerRequiresRight").hasClass("show")) $('#liUnassignFromCustomerRequiresRight').removeClass('enabled');
            //            if ($("#liUnassignFromCustomerRequiresRight").hasClass("show")) $('#liUnassignFromCustomerRequiresRight').addClass('disabled');
            //            if ($("#liAssignToCustomerRequiresRight").hasClass("show")) $('#liAssignToCustomerRequiresRight').removeClass('disabled');
            //            if ($("#liAssignToCustomerRequiresRight").hasClass("show")) $('#liAssignToCustomerRequiresRight').addClass('enabled');
            //        }
            //        else {
            //            if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').removeClass('enabled');
            //            if ($("#liThirdPartyAccessRequiresRight").hasClass("show")) $('#liThirdPartyAccessRequiresRight').addClass('disabled');
            //            if ($("#liUnassignFromCustomerRequiresRight").hasClass("show")) $('#liUnassignFromCustomerRequiresRight').removeClass('enabled');
            //            if ($("#liUnassignFromCustomerRequiresRight").hasClass("show")) $('#liUnassignFromCustomerRequiresRight').addClass('disabled');
            //            if ($("#liAssignToCustomerRequiresRight").hasClass("show")) $('#liAssignToCustomerRequiresRight').removeClass('enabled');
            //            if ($("#liAssignToCustomerRequiresRight").hasClass("show")) $('#liAssignToCustomerRequiresRight').addClass('disabled');
            //        }
            //    });
        }
    }

    HideAllContextMenus() {
        $("#gensetcontextmenu").hide();
        $(".gensetcontext-menu").hide();
        $("#drycontextmenu").hide();
        $(".drycontext-menu").hide();
        $("#chassiscontextmenu").hide();
        $(".chassiscontext-menu").hide();
        $("#contextmenu").hide();
        $(".context-menu").hide();
    }

    copyRowsToClipBoard() {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: false });//RCNG-225
    }

    copyRowsWithHeadersToClipBoard() {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: true });//RCNG-225
    }
    //1477-start
    popUpRetire() {
        IsTriggered = false;
        RCNGWindow.ConfirmWindow.showConfirmBox("By default, a retired asset does not appear in search results, nor does it contribute to the information collected by most dashboard widgets. Continue?",
            self.onYesRetire.bind(this),
            self.onCancelGensetStatusGrid.bind(this));
    }
    popUpReactivate() {
        IsTriggered = false;
        RCNGWindow.ConfirmWindow.showConfirmBox("By default, a reactivated asset appears in search results and contributes to the information collected by most dashboard widgets. Continue?",
            self.onYesReactivate.bind(this),
            self.onCancelGensetStatusGrid.bind(this));
    }

    onYesRetire() {
        if (!IsTriggered) {
              IsTriggered = true;
            var commandUnits = this.getForwardCommandUnits()
            RCNGWindow.ConfirmWindow.close();
            $('#globalLoader').show();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/asset/RetireAsset', { method: 'POST', body: JSON.stringify(commandUnits), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    $('#globalLoader').hide();
                    if (result === "success") {
                        PopupWindow.showErrorMessage("Alert", "Asset(s) Retired.");
                        self.refreshStatusGrid();
                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", "Error Occured.");
                    }
                });
        }
    }
    onYesReactivate() {
        if (!IsTriggered) {
            IsTriggered = true;
            var commandUnits = this.getForwardCommandUnits();
            $('#globalLoader').show();
            RCNGWindow.ConfirmWindow.close();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/asset/ReactivateAsset', { method: 'POST', body: JSON.stringify(commandUnits), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    $('#globalLoader').hide();
                    if (result === "success") {
                        PopupWindow.showErrorMessage("Alert", "Asset(s) Reactivated.");
                        self.refreshStatusGrid();
                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", "Error Occured.");
                    }
                });
        }
    }
    onCancelGensetStatusGrid() {
        RCNGWindow.ConfirmWindow.close();
    }
    getForwardCommandUnits() {
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        var userData = JSON.parse(sessionStorage.getItem('UserInfo'));
        var commandUnits = [];
        if (this.state.selectedItems.length > 0) {
            forEach(this.state.selectedItems, function (value, key) {
                var commandUnitObject = {
                    "AssetMasterID": value.AssetMasterID,
                    "AssetNumber": value.AssetNumber,
                    "RCDMasterID": value.RCDMasterID,
                    //"DCCurrentConditionID": value.DCCurrentConditionID,
                    //"DCConditionID": value.DCConditionID,
                    "RCDID": value.RCDID
                };

                commandUnits.push(commandUnitObject);
            });
        }
        else {
            alert('Please select at least one record to proceed.');
        }
        return commandUnits;
    }
    //1477-end
    getGensetContextMenuItems = params => {
        //TODO : after test uncommnet below line
        //RCUtils.HighlightCurrentGridRow(params,"AssetNumber",self.state.selectedItems);
        if (params != null && params != undefined && params.node != null && params.node != undefined && !params.node.group) {
            var selectflag = false;
            var selectedCell = params.api.getFocusedCell();
            var selectedRowIndex = selectedCell.rowIndex;
            var currentRow = params.api.getDisplayedRowAtIndex(selectedRowIndex);
            if (currentRow != null && currentRow != "undefined" && !currentRow.group) {
                var currentRowId = currentRow.id;
                coppiedData = params.value;
                var selectedrowNode = params.api.getRowNode(currentRowId);
                var assetNumber = selectedrowNode.data.AssetNumber;
                params.api.forEachLeafNode((newRowNode, index) => {
                    if ((newRowNode.data.AssetNumber === assetNumber)) {
                        selectedrowNode = newRowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, (index, item) => {
                    if (item.AssetNumber == selectedrowNode.data.AssetNumber) {
                        selectflag = true;
                        return false;
                    }
                });
                if (!selectflag)
                    params.api.deselectAll();
                selectedrowNode.setSelected(true);
            }
            var result = [
                {
                    name: 'Copy',
                    subMenu: [
                        {
                            name: 'Copy Cell',
                            action: () => {
                                //this.reeferContextMenuClick("Copy");
                                var cellContent = this.ProcessCellForClipboard(params);
                                params.api.clipboardService.copyDataToClipboard(cellContent);

                            }
                        },
                        {
                            name: 'Copy Row(s)',
                            action: () => {
                                this.copyRowsToClipBoard();
                            }
                        },
                        {
                            name: 'Copy Row(s) with Headers',
                            action: () => {
                                this.copyRowsWithHeadersToClipBoard();
                            }
                        },
                    ],
                },
                //'copy',
                //'copyWithHeaders',
                {
                    name: 'Map',
                    action: () => {
                        this.gensetContextMenuClick("Map");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('152'),
                },
                {
                    name: 'Current Details',
                    action: () => {
                        this.gensetContextMenuClick("Details");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('156'),
                    disabled: UserRights.checkMenuItemDisabledForGenset(params, 'CurrentDetails'),
                },
                {
                    name: 'History',
                    action: () => {
                        this.gensetContextMenuClick("History");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('153'),
                },
                {
                    name: 'Command History',
                    action: () => {
                        this.gensetContextMenuClick("CommandStatus");
                    }, 
                    cssClasses: UserRights.checkMenuItemVisibilityGT1030(params, 'CommandStatus', '157'),
                    //UserRights.checkMenuItemVisibility('157'),
                },
                {
                    name: 'Commands',
                    cssClasses: UserRights.checkMenuItemVisibilityGT1030(params, 'Commands', '166'),
                    //cssClasses: UserRights.checkMenuItemVisibility('166'),
                    subMenu: [
                        {
                            name: 'Reporting',
                            cssClasses: UserRights.checkMenuItemVisibility('166'),
                            subMenu: [
                                {
                                    name: 'Ping / Report',
                                    action: () => {
                                        this.popUpPing();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibility('166'),
                                },
                            ],
                        },
                    ],
                },
                {
                    name: 'Third Party Access',
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('168,169'),

                    disabled: UserRights.checkMenuItemDisabledForGenset(params, 'ThirdPartyAccess'),
                    subMenu: [
                        {
                            name: 'Assign / Edit',
                            action: () => {
                                this.popUpAssignToCustomer();
                            },
                            cssClasses: UserRights.checkMenuItemVisibility('168'),
                            disabled: UserRights.checkMenuItemDisabledForGenset(params, 'Assign'),
                        },
                        {
                            name: 'Unassign From Customer',
                            action: () => {
                                this.popUpUnAssignFromCustomer();
                            },
                            cssClasses: UserRights.checkMenuItemVisibility('169'),
                            disabled: UserRights.checkMenuItemDisabledForGenset(params, 'UnAssign'),
                        },
                    ],
                },
                {
                    name: 'Inventory',
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('255,256'),//RCNG-1176
                    disabled: UserRights.checkMenuItemDisabled(params, 'RetireOrReactivate'),
                    subMenu: [
                        {
                            name: 'Retire',
                            action: () => {
                                this.popUpRetire();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleInventory('255', params, "Retire"),
                        },
                        {
                            name: 'Reactivate',
                            action: () => {
                                this.popUpReactivate();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleInventory('256', params, "Reactivate"),
                        },
                    ],
                },
                'separator',
                {
                    name: 'Export',
                    action: () => {
                        this.popUpExport();
                    },
                },
                {
                    name: 'Send Email',
                    action: () => {
                        this.popUpSendEmail();
                    },
                },
            ];
            return result;
        }
    };
    
    getGensetContextMenuItemsOld(params: any) {
        var flag = false;
        var selected = params.api.getFocusedCell();
        var setRowIndex = selected.rowIndex;
        var row = params.api.getDisplayedRowAtIndex(setRowIndex);
        if (row != null && row != "undefined" && !row.group) {
            var rowId = row.id;
            var selectedrowNode = params.api.getRowNode(rowId);
            //var selectedrowNode = params.api.getRowNode(setRowIndex);
            //var tempArray = [];// if sort is clicked save in temp array
            //params.api.forEachLeafNode(function (rowNode, index) {
            //    tempArray.push(rowNode);
            //});

            //var resortitem = tempArray[setRowIndex];
            var sortflage = false;
            //var reeferid = resortitem.data.ReeferID;
            var gensetCurrentConditionId = selectedrowNode.data.GensetCurrentConditionId;
            params.api.forEachLeafNode(function (NewrowNode, index) {
                if ((NewrowNode.data.GensetCurrentConditionId === gensetCurrentConditionId)) {
                    selectedrowNode = NewrowNode;
                    return false;
                }
            });
            $.each(self.state.selectedItems, function (index, item) {
                if (item.GensetCurrentConditionId == selectedrowNode.data.GensetCurrentConditionId) {
                    flag = true;
                    return false;
                }
            });
            if (!flag)
                params.api.deselectAll();
            selectedrowNode.setSelected(true);
        }
        /*
        var flag = false;
        var selected = params.api.getFocusedCell();
        var selectedrowNode = params.api.getRowNode(selected.rowIndex);
        var tempArray = [];// if sort is clicked save in temp array
        params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
            tempArray.push(rowNode);
        });

        var resortitem = tempArray[selected.rowIndex];
        var sortflage = false;
        var gensetCurrentConditionId = resortitem.data.GensetCurrentConditionId;
        params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
            if ((NewrowNode.data.GensetCurrentConditionId === gensetCurrentConditionId)) {
                selectedrowNode = NewrowNode;
                return false;
            }
        });
        $.each(self.state.selectedItems, function (index, item) {            
            if (item.GensetCurrentConditionId == selectedrowNode.data.GensetCurrentConditionId) {
                flag = true;
                return false;
            }
        });
        if (!flag)
            params.api.deselectAll();
        params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
        */
        // var rowNode = params.api.getRowNode(selected.rowIndex);
        //params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
               
        $(document).contextmenu(function (e) {
            self.HideAllContextMenus(); // landing page have multiple context menus close all
            var divmenuwidth = 390;
            var offset = $("#Grid-AlignGenset .ag-column-hover").offset();
            if ((typeof (offset) != 'undefined') && offset != null) {
                if (offset.left > 400) {
                    divmenuwidth = 390;
                } else if (offset.left > 890) {
                    divmenuwidth = 690;
                } else {
                    divmenuwidth = 40;
                }
            }
            /// var relativeX = (e.pageX - offset.left);
            if ((typeof (offset) != 'undefined') && offset != null) {
                var relativeY = (e.pageY - offset.top + 50);
            }
            var relativeX = e.pageX - divmenuwidth;

            if (relativeX > ($(window).width() - (divmenuwidth + 5))) {
                relativeX = relativeX - (divmenuwidth + 5);
            }
            var height = $(window).height() - 200;
            var halfheight = ($(window).height()) / 2;
            if (height < relativeY) {
                relativeY = (relativeY - halfheight) + 20;
            }
            $(".gensetcontext-menu").css({
                top: relativeY + "px",
                left: relativeX + "px",
                position: "absolute"
            });           

        });     
		
		
        $("#Grid-AlignGenset .ag-cell").unbind("contextmenu");
        $("#Grid-AlignGenset .ag-cell").bind('contextmenu', function (e) {
            var flag = false;
            var selected = params.api.getFocusedCell();
            var setRowIndex = selected.rowIndex;
            var row = params.api.getDisplayedRowAtIndex(setRowIndex);
            if (row != null && row != "undefined" && !row.group) {
                var rowId = row.id;
                var selectedrowNode = params.api.getRowNode(rowId);
                //var selectedrowNode = params.api.getRowNode(setRowIndex);
                //var tempArray = [];// if sort is clicked save in temp array
                //params.api.forEachLeafNode(function (rowNode, index) {
                //    tempArray.push(rowNode);
                //});

                //var resortitem = tempArray[setRowIndex];
                var sortflage = false;
                //var reeferid = resortitem.data.ReeferID;
                var gensetCurrentConditionId = selectedrowNode.data.GensetCurrentConditionId;
                params.api.forEachLeafNode(function (NewrowNode, index) {
                    if ((NewrowNode.data.GensetCurrentConditionId === gensetCurrentConditionId)) {
                        selectedrowNode = NewrowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, function (index, item) {
                    if (item.GensetCurrentConditionId == selectedrowNode.data.GensetCurrentConditionId) {
                        flag = true;
                        return false;
                    }
                });
                if (!flag)
                    params.api.deselectAll();
                selectedrowNode.setSelected(true);
            }
            /*
            var flag = false;
            var selected = params.api.getFocusedCell();
            var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
            var tempArray = [];// if sort is clicked save in temp array
            params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
                tempArray.push(rowNode);
            });
            var resortitem = tempArray[selected.rowIndex];
            var sortflage = false;
            var gensetCurrentConditionId = resortitem.data.GensetCurrentConditionId;
            params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
                if ((NewrowNode.data.GensetCurrentConditionId === gensetCurrentConditionId)) {
                    selectedrowNode = NewrowNode;
                    return false;
                }
            });
            $.each(self.state.selectedItems, function (index, item) {
                if (item.GensetCurrentConditionId == selectedrowNode.data.GensetCurrentConditionId) {
                    flag = true;
                    return false;
                }
            });
            if (!flag)
                params.api.deselectAll();
            params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
            */
            var reSized = self.props.isResizeClicked;
            if (JSON.stringify(reSized) === 'false') {
                var divmenuwidth = 280;
            } else {
                var divmenuwidth = 20;
            } 
            var offset = $("#Grid-AlignGenset .ag-column-hover").offset();
            var relativeY = (e.pageY - offset.top);
            var relativeX = e.pageX - divmenuwidth;

            if (relativeX > ($(window).width() - (divmenuwidth + 5))) {
                relativeX = relativeX - (divmenuwidth + 5);
            }
            var height = $(window).height();
            var halfheight = ($(window).height()) / 2;
            //if ((window as any).clipboardData) {
            //    if (height < relativeY + 560) {
            //        //if IE Browser 
            //        relativeY = (relativeY - 150);
            //    }
            //}
            //else
            if (JSON.stringify(reSized) === 'false') {
                // click on below window half height make to Y top to static value 140px
                if (relativeY > 140) {
                    relativeY = 140;
                }
            } else {
                var height = $(window).height() - 200;
                var halfheight = ($(window).height()) / 2;
                if ((window as any).clipboardData) {
                    if (height < relativeY + 60) {
                        //if IE Browser 
                        relativeY = (relativeY - 150);
                    }
                }
                else if (height < relativeY + 378) {
                    relativeY = (relativeY - 135);
                }
            }
            $(".gensetcontext-menu").css({
                top: relativeY + "px",
                left: relativeX + "px",
                position: "absolute"
            });
            $("#gensetcontextmenu").show();
            $(".gensetcontext-menu").show();
            e.preventDefault();
            return false;
        });

        $(document).contextmenu(function () {
            return false;
        });

        $(document).bind('gensetcontextmenu click', function () {
            $(".gensetcontext-menu").hide();
        });

        $('.gensetcontext-menu').bind('gensetcontextmenu', function () {
            return false;
        });
        $('.gensetcontext-menu').on('click', 'li', function () {
            $(".gensetcontext-menu").hide();
        });
    }
    
    defaultColDef() {
        return [{
            flex: 1,
            minWidth: 100,
            filter: true,
            sortable: true,
            enableRowGroup: true,
            resizable: true,
        }]
    }
   

    createColumnDefs() {
        return [
            {
                headerName: 'Group',
                minWidth: 210,
                hide: true
            },
            {
                headerName: 'State Indicators',
                children: [
                    //{ headerName: "CC", field: "CCSeverityLevelGenset", width: 65, cellRenderer: Formatters.stringTypeFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "SW", field: "IgnitionOn", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        filterParams: { valueGetter: params => { return GensetFormatters.gensetSwitchFormatterImgForFilter(params); } },
                        resizable: true, width: 65, valueGetter: (params) => { return GensetFormatters.gensetSwitchSorting(params); },
                        cellRenderer: GensetCellRender.gensetSwitchFormatterImg, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "ENG", field: "GensetRunning", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        filterParams: { valueGetter: params => { return GensetFormatters.gensetRunningFormatterForFilter(params); } }, resizable: true, valueGetter: (params) => { return GensetFormatters.EngineSorting(params); }, width: 65, cellRenderer: GensetCellRender.gensetRunningFormatter, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "VSL", field: "VesselCd", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80,
                        valueGetter: (params) => { return Formatters.vesselCdSorting(params); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this)
                    }
                    ,
                    { headerName: "INV", field: "AssetState", enableRowGroup: true, cellClass: 'myExcelStyle', filter: true, sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "AssetState"); }, cellRenderer: GensetCellRender.AssetStateFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) }
                    //,{ headerName: "ALRT", field: "AlertSeverityID", width: 65, cellRenderer: (params) => { return Formatters.statusIndicatorWithDescriptionForALR(params, self.state.reeferFormatter.AlertMasterList); }, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
            },
            {
                headerName: 'Assignments',
                children: [
                    {
                        headerName: "Assigned to", field: "CustomerName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        valueGetter: params => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSortingFor3P(params.data.CustomerName); },
                        filterParams: { valueGetter: params => { return Formatters.stringTypeFormatterFor3PForFilter(params); } }, resizable: true, cellRenderer: GensetCellRender.stringTypeFormatterFor3P, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
                    }
                ]
            },
            {
                headerName: 'Identification',
                children: [
                    {
                        headerName: "OEM", field: "OEMTypeCD", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        filterParams: { valueGetter: params => { return GensetFormatters.oemTypeFormatterGensetForFilter(params); } }, resizable: true, width: 100,
                        valueGetter: params => { if (params.data != null && params.data != undefined) return Formatters.OEMTypeValueFormatter(params.data.OEMTypeCD); }, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "Genset ID", field: "AssetNumber", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 150,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.AssetNumber); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "Model", field: "ModelType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 120,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ModelType); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    //{ headerName: "Cust. Model", field: "ModelNumber", width: 120, cellRenderer: Formatters.stringTypeFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Form", field: "FormType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 120,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.FormType); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "Tank sz (gal)", field: "GensetTankSize", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 120,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.GensetTankSize); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "Mfd. year", field: "ManufacturedDate", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        filterParams: { valueGetter: params => { return Formatters.YearFromdateTypeFormatterForFilter(params); } }, resizable: true, width: 80, valueGetter: (params) => { return Formatters.ManufactureYearSorting(params); }, cellRenderer: Formatters.YearFromdateTypeFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    //{ headerName: "Profile", field: "Profile", width: 80, cellRenderer: Formatters.stringTypeFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "Engine", field: "EngineType", width: 80, cellRenderer: Formatters.stringTypeFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "Generator", field: "GeneratorType", width: 80, cellRenderer: Formatters.stringTypeFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "ID Plate", field: "IdPlate", width: 80, cellRenderer: Formatters.stringTypeFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "Assigned", field: "Assigned", width: 80, cellRenderer: Formatters.stringTypeFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
            },
            {
                headerName: 'Report Date/Time and Location',
                children: [
                    { headerName: "Event", field: "EventDescription", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, cellRenderer: GensetCellRender.stringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Event time", field: "EventDTTM", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterEventDTTMForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },

                    {
                        headerName: "Device fence", field: "FenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.FenceName); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device fence ID", field: "FenceNameID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.FenceNameID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Server fence", field: "BackendGeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.BackendGeofenceName); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    //{ headerName: "Region Fence", field: "RegionGeofenceName", cellRenderer: Formatters.stringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Server fence ID", field: "BackendGeofenceNameID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.BackendGeofenceNameID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    //{ headerName: "Region Fence ID", field: "RegionGeofenceNameID", cellRenderer: Formatters.stringTypeFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Geofence revision", field: "GeofenceDefinitionRevision", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.floatTypeSorting(params.data.GeofenceDefinitionRevision); }, cellRenderer: GensetCellRender.floatTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    { headerName: "Loc coords", field: "GPSCoords", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, filterParams: { valueGetter: params => { return Formatters.GPSCoordsForFilter(params); } }, cellRenderer: GensetCellRender.GPSCoordsFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    {
                        headerName: "Loc age (h:m:s)", field: "GPSLastLock", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        filterParams: { valueGetter: params => { return Formatters.secondsToTimeConverterFilter(params); } },
                        valueGetter: params => { return Formatters.secondsToTimeConverterFilter(params); }, resizable: true, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Loc HDOP", field: "GPSHDOP", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.GPSHDOPTypeSorting(params.data.GPSHDOP, params.data.GPSLockState); }, cellRenderer: GensetCellRender.GPSfloatTypeValueFormatter, columnGroupShow: 'open', width: 130, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Loc sat ct", field: "GPSSatelliteCount", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.GPSSatCountTypeSorting(params.data.GPSSatelliteCount, params.data.GPSLockState); }, cellRenderer: GensetCellRender.GPSfloatTypeValueFormatter, columnGroupShow: 'open', width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Speed", field: "Speed", headerValueGetter: Formatters.SpeedHeaderFormatter, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, columnGroupShow: 'open',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.floatTypeSorting(params.data.Speed); }, cellRenderer: GensetFormatters.gensetSpeedValueFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {// RCNG 1257
                        headerName: "Address", field: "Address", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Address"); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), columnGroupShow: 'open', cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "City", field: "City", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.City); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "State", field: "State", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.State); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Country", field: "Country", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.Country); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Zip", field: "ZipCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ZipCode); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, columnGroupShow: 'open', width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    }
                ]
            },
            {
                headerName: 'Genset Status and Sensor Reporting',
                children: [
                    //{ headerName: "Alerts", field: "Alerts", cellRenderer: (params) => { return Formatters.AlertDescriptionFormatter(params, self.state.reeferFormatter.AlertMasterList); }, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)},
                    {
                        headerName: "Battery (V)", field: "ExtBattVoltage", enableRowGroup: true, cellClass: 'bigInt', sortable: true, filter: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.BattVoltageSorting(params.data.ExtBattVoltage); }, cellRenderer: Formatters.BattVoltageValueFormatter,
                        filterParams: { valueGetter: params => { return Formatters.BattVoltageFormatterForFilter(params); } }, resizable: true, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Fuel sensor", field: "HasFuelSensor", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, getQuickFilterText: GensetFormatters.FuelSensorQuickFilterFormatter,
                        filterParams: { valueGetter: params => { return GensetFormatters.fuelSensorTrace(params); } }, resizable: true, valueGetter: (params) => { return GensetFormatters.FuelSensorSorting(params); }, cellRenderer: GensetFormatters.fuelSensorTrace, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Fuel level (gal)", field: "FuelLevel", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, getQuickFilterText: GensetFormatters.FuelLevelGalQuickFilterFormatter,
                        filterParams: { valueGetter: params => { return GensetFormatters.fillLevelGalTrace(params); } }, resizable: true, valueGetter: (params) => { return GensetFormatters.FuelLevelGalSorting(params); }, cellRenderer: GensetFormatters.fillLevelGalTrace, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Fuel level", field: "FractionDisplay", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, getQuickFilterText: GensetCellRender.FuelLevelQuickFilterFormatter,
                        valueGetter: (params) => { return GensetFormatters.FuelLevelSorting(params); }, cellRenderer: GensetCellRender.fillLevelTrace, width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Reefer ID", field: "ReeferID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 140,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ReeferID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Reefer state", field: "ReeferStateDsc", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ReeferStateDsc); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Uses LOP", field: "HasOilPressureSwitch", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        resizable: true, valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.YesNoValueSorting(params.data.HasOilPressureSwitch); },
                        filterParams: { valueGetter: params => { return GensetFormatters.YesNoConverterForFilter(params); } }, columnGroupShow: 'open', width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    }
                ]
            },
            {
                headerName: "Device Status",
                children: [
                    {
                        headerName: "Device ID", field: "RCDID", enableRowGroup: true,  sortable: true, filter: true, resizable: true, cellClass: 'bigInt',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.RCDID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device Data Time", field: "DeviceDataTime", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterDeviceDataTimeForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, cellRenderer: Formatters.dateTypeFormatter, width: 150, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device FW", field: "FirmwareVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, columnGroupShow: 'open',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.FirmwareVersion); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device bat (V)", field: "BattVoltage", enableRowGroup: true, cellClass: 'bigInt', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.BattVoltageSorting(params.data.BattVoltage); },
                        filterParams: { valueGetter: params => { return Formatters.DeviceBattVoltageFormatterForFilter(params); } }, cellRenderer: Formatters.BattVoltageValueFormatter,
                        width: 130, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Reporting (min)", field: "RCDReportingInterval", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.RCDReportingInterval); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },

                    {
                        headerName: "MSISDN", field: "MSISDN", enableRowGroup: true,  sortable: true, filter: true, resizable: true, columnGroupShow: 'open', cellClass: 'bigInt',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.MSISDN); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "IMSI", field: "SIM_IMSI", enableRowGroup: true, sortable: true, filter: true, resizable: true, columnGroupShow: 'open', cellClass: 'bigInt',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.SIM_IMSI); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "ICCID", field: "ICCID", enableRowGroup: true, sortable: true, filter: true, resizable: true, columnGroupShow: 'open', cellClass: 'bigInt',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ICCID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "EUI", field: "EUI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, columnGroupShow: 'open',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.EUI); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Cell signal", field: "RSSI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.RSSISorting(params); },
                        filterParams: { valueGetter: params => { return Formatters.RSSITypeFormatterFilter(params); } }, cellRenderer: GensetCellRender.RSSITypeFormatter, width: 80, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "MCC (country)", field: "CountryName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.CountryName); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "MNC", field: "MNC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.MNC); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, columnGroupShow: 'open', width: 70, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "LAC", field: "TowerLocalizationAreaCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, columnGroupShow: 'open',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.TowerLocalizationAreaCode); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Tower ID", field: "TowerBaseStationID", enableRowGroup: true,  sortable: true, filter: true, resizable: true, columnGroupShow: 'open', cellClass: 'bigInt',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.TowerBaseStationID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    //{ headerName: "Speed (mph)", field: "Speed", columnGroupShow: 'open', cellRenderer: Formatters.floatTypeFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)},
                    {
                        headerName: "Device config", field: "DeviceConfig", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        filterParams: { valueGetter: params => { return Formatters.GuestReeferModeFormatterForFilter(params); } }, resizable: true, columnGroupShow: 'open', cellRenderer: Formatters.GuestReeferModeFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    {
                        headerName: "Device type", field: "DeviceType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, columnGroupShow: 'open',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.DeviceType); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    }
                ]
            },
            {
                headerName: "Misc.",
                children: [
                    {
                        headerName: "Receipt time", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterCreatedDTTMForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "CreatedDTTM", cellRenderer: Formatters.dateTypeFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this)
                    },
                    { headerName: "Comments", field: "CommentExistsGenset", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, cellRenderer: GensetCellRender.CommentExistsFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) }
                ]
            }
        ];
    }

    clearGridRowSelection(params: any) {
        self.props.renderClearSelection();
        params.api.deselectAll();
    }
    onSavecolumnorder(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var ColumnValues = params.columnApi.getColumnState().map(col => col.colId);
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data != null) {
                    rowGroupItems = currentGropup;
                    $.each(ColumnValues, function (index, value) {
                        var dataresult = data.filter(x => x.ColumnNm.trim().toUpperCase() == value.trim().toUpperCase());
                        if (dataresult.length > 0) {
                            selectedColumnIds.push(dataresult[0].InterfaceExportColumnId);
                            selectedColumnValues.push(dataresult[0].ColumnNm);
                        }
                    });
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
            });
    }
    onSaveGridRowGroupState(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = currentGropup;
                    selectedColumnIds = preferenceData.SelectedColumnIds;
                    selectedColumnValues = preferenceData.SelectedColumnValues;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
                else {
                    // if no userpreference record in db 
                    rowGroupItems = currentGropup;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    // var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, SelectedRowGroups: rowGroupItems };
                    var rowGroupDataToSave = { colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(rowGroupDataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });

                }
            });
        
        //var maxRowGroupLimit = 4;
        //var current = params.columns.length;

        //if (current === maxRowGroupLimit) {
        
        //    groupingDisabled = true;
        //    PopupWindow.showErrorMessage("RowGroup!", "max limit reached, please remove a group before adding a new one");
        
        //    let colDefs = [];
        //    let cols = params.columnApi.getAllColumns();
        //    cols.forEach(col => {
        //        let newColDef = { ...col.colDef, enableRowGroup: false };
        //        colDefs.push(newColDef);
        //    });
        //    params.api.setColumnDefs(colDefs);
        //}
        //if (current < maxRowGroupLimit && groupingDisabled) {
        //    let colDefs = [];
        //    let cols = params.columnApi.getAllColumns();
        //    cols.forEach(col => {
        //        let newColDef = { ...col.colDef, enableRowGroup: true };
        //        colDefs.push(newColDef);
        //    });
        //    params.api.setColumnDefs(colDefs);
        //}
    }

    groupRowInnerRenderer(params) {
        //self.clearGridRowSelection(params);
        var fieldName = params.node.field;
        var fieldValue = params.node.key;
        //var columnDisplayName = params.node.columnApi.gridOptions.columnApi.rowGroupColumns[0].colDef.headerName;
        var colDef = params.node.rowGroupColumn.colDef;//WI 26719
        var columnDisplayName = params.node.rowGroupColumn.colDef.headerName;//WI 26719

        //if (fieldName.toString() == "EventDTTM" || fieldName.toString() == "DeviceDataTime" || fieldName.toString() == "CreatedDTTM")
        //    return Formatters.dateTypeFormatterGrouping(fieldValue);

        if (fieldValue == "-NA-" || (fieldValue == "-999" && self.validateFieldName(fieldName.toString().trim())))
            return "*No " + columnDisplayName;

        switch (fieldName.toString().trim()) {
            case "IgnitionOn":
                return GensetCellRender.GensetSwitchFormatterGrouping(fieldValue);
            case "GensetRunning":
                return GensetCellRender.EngineSortingFormatterGrouping(fieldValue);
            case "OEMTypeCD":
                return Formatters.OEMTypeFormatterGrouping(fieldValue);
            //case "VesselCd":
            //    return fieldValue == "-NA-" ? "*No VSL" : fieldValue;
            case "CustomerName":
                return fieldValue == JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "*No Assigned To" : fieldValue;
            case "RSSI":
                return GensetCellRender.RSSIFormatterGrouping(fieldValue);
            //case "HasOilPressureSwitch":
            //    return Formatters.YesNoFormatterGrouping(fieldValue);
            case "FuelLevel":
                return Formatters.FuelLevelGalGrouping(fieldValue);
            case "FractionDisplay":
                return GensetCellRender.FillLevelTraceGrouping(fieldValue);
            case "HasFuelSensor":
                return Formatters.FuelSensorGrouping(fieldValue);
            case "ManufacturedDate":
                return fieldValue == 0 ? '*No Mfd. Year' : fieldValue;
            case "DeviceConfig":
                return Formatters.GuestReeferModeGrouping(fieldValue);
            case "CommentExistsGenset":
                return fieldValue == 0 ? "Comments" : "*No Comments";
            case "EventDTTM":
            case "DeviceDataTime":
            case "CreatedDTTM":
                return Formatters.dateTypeGrouping(fieldValue, fieldName, params);
            case "GPSCoords":
                return Formatters.GPSCoordsFormatterGrouping(fieldValue, params);
            //case "GPSLastLock":
            //    return fieldValue == "-NA-" ? "*No Last GPS (h:m:s)" : fieldValue;
            //case "ExtBattVoltage":
            //    return fieldValue == "-NA-" ? "*No Battery (V)" : fieldValue;
            case "Sensor1Value_GT1200": case "Sensor2Value_GT1200": case 'Sensor3Value_GT1200': case 'Sensor4Value_GT1200': case "Sensor5Value_GT1200": case "Sensor6Value_GT1200": case 'Sensor7Value_GT1200': case 'Sensor8Value_GT1200':
            case "Sensor1Value_GT1020": case "Sensor2Value_GT1020": case 'Sensor3Value_GT1020': case 'Sensor4Value_GT1020': case "Sensor5Value_GT1020": case "Sensor6Value_GT1020": case 'Sensor7Value_GT1020': case 'Sensor8Value_GT1020':
            case "Sensor1Value_ST9100": case "Sensor2Value_ST9100": case 'Sensor3Value_ST9100': case 'Sensor4Value_ST9100': case "Sensor5Value_ST9100": case "Sensor6Value_ST9100": case 'Sensor7Value_ST9100': case 'Sensor8Value_ST9100':
            case "Sensor1Value_GT1030": case "Sensor2Value_GT1030": case 'Sensor3Value_GT1030': case 'Sensor4Value_GT1030': case "Sensor5Value_GT1030": case "Sensor6Value_GT1030": case 'Sensor7Value_GT1030': case 'Sensor8Value_GT1030':
                return Formatters.SensorGrouping(fieldName.toString().trim(), fieldValue, gensetAssetSensors, colDef);
            case "AssetState":
                return GensetCellRender.AssetStateFormatterGrouping(fieldValue);
            default:
                return fieldValue
        }
    }

    validateFieldName(fieldName: any) {
        var IsValid = true;
        switch (fieldName) {
            case "Sensor1Value_GT1200": case "Sensor2Value_GT1200": case 'Sensor3Value_GT1200': case 'Sensor4Value_GT1200': case "Sensor5Value_GT1200": case "Sensor6Value_GT1200": case 'Sensor7Value_GT1200': case 'Sensor8Value_GT1200':
            case "Sensor1Value_GT1020": case "Sensor2Value_GT1020": case 'Sensor3Value_GT1020': case 'Sensor4Value_GT1020': case "Sensor5Value_GT1020": case "Sensor6Value_GT1020": case 'Sensor7Value_GT1020': case 'Sensor8Value_GT1020':
            case "Sensor1Value_ST9100": case "Sensor2Value_ST9100": case 'Sensor3Value_ST9100': case 'Sensor4Value_ST9100': case "Sensor5Value_ST9100": case "Sensor6Value_ST9100": case 'Sensor7Value_ST9100': case 'Sensor8Value_ST9100':
            case "Sensor1Value_GT1030": case "Sensor2Value_GT1030": case 'Sensor3Value_GT1030': case 'Sensor4Value_GT1030': case "Sensor5Value_GT1030": case "Sensor6Value_GT1030": case 'Sensor7Value_GT1030': case 'Sensor8Value_GT1030':
                { IsValid = false; }
                break;
        }
        return IsValid;
    }

    refreshStatusGrid() {        
        selectedRowIndex = -1;
        this.props.clearGridHeaderExtension();
        GensetHistoryGrid.ClearHistoryGridData();
        this.setState({
            selectedItems: [],
            isChangeDeforstInterval: false,
            pretripCmd: null,
            modelTitle: '',
            popUpHtml: ''
        }, () => this.GensetSearchFilter(self.props.statusFilter, false, false));
    }

    static refreshDashboardGrid() {
        self.refreshStatusGrid();
    }   

    static refreshToggleFilters() {
        if (self != undefined) {
            if (self.state.ToggleSearchParams != undefined && self.state.ToggleSearchParams != null)
                self.setState({ ToggleSearchParams: null });
            self.setState({ rowData: [] });
        }
    }

    closeToolBarGridPreferenceModel() {
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }

    ComponentRenderingForCommands(popUpName: string, userData: any) {
        switch (popUpName) {
             case 'SendEmail':
                return <EmailControlExcelPreference reeferStatusResult={self.state.selectedItems} columnDefinition={self.state.columnDefs}
                    colDefs2={columnDefs2} parentchild={"C"} formName={"GensetGrid"} FunctionID={functionId}
                    gridApiParams={self.state.gridApiParams} onlyselected={true}
                    widgetId={12} dashboardPreferenceId={this.props.dashboardPreferenceId}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    isIncludeRowGroup={self.state.gridApiParams.gridOptionsWrapper == undefined
                        && self.state.gridApiParams.gridOptionsWrapper == null ? false :
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false} sensorData={gensetAssetSensors}/>
            case 'Export':
                return <ExportToExcelConfirmationWindow formName={"GensetGrid"} functionId={functionId} gridApiParams={self.state.gridApiParams}
                    gridData={self.state.selectedItems} colDefs={this.state.columnDefs} colDefs2={columnDefs2}
                    parentchild={"C"} formname={"GensetGrid"} onlyselected={true}
                    widgetId={12} dashboardPreferenceId={this.props.dashboardPreferenceId}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    closeModelDialog={self.closeToolBarGridPreferenceModel.bind(this)} sensorData={gensetAssetSensors}/>;

            case 'Ping':
                return <GensetPingControl gensetData={self.state.selectedItems} refreshGrid={"home"} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></GensetPingControl>;     
            case 'AssignCustomer':
                return <AssignToCustomer refreshStatusGrid={self.refreshStatusGrid.bind(this)} assetData={self.state.selectedItems} CustomerAccessData={customerAccessData} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}/>;
            case 'UnAssignCustomer':
                return <UnassignReefersFromCustomer refreshStatusGrid={self.refreshStatusGrid.bind(this)} SelectedReefersData={self.state.selectedItems} CustomerAccessData={customerAccessData} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}/>;
        }
    }

    RenderContextMenuPopUp(popUpName: string, isCommands: boolean) {
        var gensetData = self.state.selectedItems;
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        var userData = JSON.parse(sessionStorage.getItem('UserInfo'));
        var filterSet: server.GensetStatusUI[];
        filterSet = gensetData;
        var filterParams = JSON.stringify(filterSet);       
        if (!isCommands) {
            self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData) }, () => { self.props.getCommandPopupTitle(this.state.modelTitle); self.props.getCommandPopupContent(this.state.popUpHtml); });
            $('#btnTriggerPopupGenset').click();  
        }        
    }

    popUpPing() {
        self.setState({ modelTitle: 'Ping' });
        self.RenderContextMenuPopUp('Ping', false);
    }

    popUpAssignToCustomer() {
        $('#globalLoader').show();
        customerAccessData = [];
        self.setState({ modelTitle: 'Assign Asset(s) to Customer' });
        var selectedUnits = "";
        if (self.state.selectedItems.length > 1) {
            $.each(self.state.selectedItems, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.AssetMasterID : selectedUnits + "," + value.AssetMasterID;
            });
        }
        else {
            selectedUnits = self.state.selectedItems[0].AssetMasterID.toString();
        }

        var filterUnitParams = JSON.stringify(self.state.selectedItems.map(x => x.AssetMasterID));
        var url = Config.ApiBaseUrl + '/api/reeferstatus/GetAssetCustomerGroups';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: filterUnitParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroupsBooking?selectedUnits=' + selectedUnits);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                customerAccessData = data;
                $('#globalLoader').hide();
                self.RenderContextMenuPopUp('AssignCustomer', false);
            });
    }

    popUpUnAssignFromCustomer() {
        $('#globalLoader').show();
        self.setState({ modelTitle: 'Unassign Asset(s) From Customer' });
        var selectedUnits = "";
        if (self.state.selectedItems.length > 1) {
            $.each(self.state.selectedItems, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.AssetMasterID : selectedUnits + "," + value.AssetMasterID;
            });
        }
        else {
            selectedUnits = self.state.selectedItems[0].AssetMasterID.toString();
        }

        var filterUnitParams = JSON.stringify(self.state.selectedItems.map(x => x.AssetMasterID));
        var url = Config.ApiBaseUrl + '/api/reeferstatus/GetAssetCustomerGroups';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: filterUnitParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroupsBooking?selectedUnits=' + selectedUnits);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                customerAccessData = data;
                $('#globalLoader').hide();
                self.RenderContextMenuPopUp('UnAssignCustomer', false);
            });
    }

    popUpSendEmail() {
        self.setState({ modelTitle: 'Send Email' });
        self.RenderContextMenuPopUp('SendEmail', false);
    }   
    
    popUpExport() {
        self.setState({ modelTitle: 'Export' });
        self.RenderContextMenuPopUp('Export', false);
    }
    exportToExcel() {  
        var arrData;
        if (self.state.selectedItems != null) {
            arrData = typeof self.state.selectedItems != 'object' ? JSON.parse(self.state.selectedItems) : self.state.selectedItems;
        }
        else {
            arrData = typeof this.state.rowData != 'object' ? JSON.parse(this.state.rowData) : this.state.rowData;
        }

        $("#globalLoader").show();
        var r = this.state.columnDefs;
        try {
            var formName = 'GensetGrid';
            var sheetData = { HeaderData: [], ColumnData: [] };
            var uri = Excel.InitializeChildGridExportToExcel(arrData, r, formName);
            this.state.exportFields.ExportData = JSON.stringify(uri);
            sheetData = Excel.ConvertCSVToJSon(uri);
            GridGensetStatusToolBar.applySheetData(sheetData, formName);
        }
        catch (ex) {
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Error in data export.");
        }
    }

    ProcessCellForClipboard(params) {
        return Formatters.CopyCommandFormatters(params);
    }

    onFirstDataRendered(params) {
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = preferenceData.SelectedRowGroups
                    if (rowGroupItems != null && rowGroupItems != undefined && rowGroupItems.length > 0) {
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setRowGroupColumns(rowGroupItems);
                    }
                    if (preferenceData.colState != null && preferenceData.colState != undefined && preferenceData.colState.length > 0) {
                        //self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnState(preferenceData.colState);
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.applyColumnState({ state: preferenceData.colState, applyOrder: false, });
                        //self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.applyColumnState(preferenceData.colState);
                    }
                }
            });

    }
    
    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;
        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    renderEmailDialog(gridData: any, colDefs: any, colDefs2: any, formName: string, parentChild: string, functionId: any, widgetId: any, gridApiParams: any, isIncludeRowGroup: boolean, sensorData:any) {
        this.props.renderDataToEmailControl(gridData, colDefs, colDefs2, formName, parentChild, functionId, widgetId, gridApiParams, isIncludeRowGroup, gensetAssetSensors);
    }

    renderGridPreferenceDialog(functionId: any, widgetId: any, gridApiParams: any, formName: string) {
        this.props.renderDataGridPreferenceControl(functionId, widgetId, gridApiParams, formName);
    }

    renderExportToExcelDialog(functionId: any, widgetId: any, gridApiParams: any, formName: string, gridData: any, colDefs: any, colDefs2: any, parentchild: any, sensorData:any) {
        this.props.renderDataGridExportToExcelControl(functionId, widgetId, gridApiParams, formName, gridData, colDefs, colDefs2, parentchild, gensetAssetSensors);
    }

    filterGensetStatusGrid(searchParam: any) {
        self.setState({ ToggleSearchParams: searchParam });
        $('#globalLoader').show();
        ReeferCallout.ResetMapPushpins();
        var gensetData = [];
        var gensetSearchData = this.props.propsGensetData;
        if (!searchParam.AllGenset && !searchParam.ReportingSWOn && !searchParam.LastReportedSWOn && !searchParam.ReportingSWOff && !searchParam.LastReportedSWOff) {
            gensetData.push(...gensetSearchData);
        }
        if (searchParam.AllGenset) {
            gensetData.push(...gensetSearchData);
        }
        if (searchParam.ReportingSWOn && !searchParam.AllGenset) {
            gensetData.push(...gensetSearchData.filter(x => x.IgnitionOn == true && x.IsReportingDelay == false));
        }
        if (searchParam.LastReportedSWOn && !searchParam.AllGenset) {
            gensetData.push(...gensetSearchData.filter(x => x.IgnitionOn == true && x.IsReportingDelay == true));
        }
        if (searchParam.ReportingSWOff && !searchParam.AllGenset) {
            gensetData.push(...gensetSearchData.filter(x => (x.IgnitionOn == false || x.IgnitionOn == null) && x.IsReportingDelay == false));
        }
        if (searchParam.LastReportedSWOff && !searchParam.AllGenset) {
            gensetData.push(...gensetSearchData.filter(x => (x.IgnitionOn == false || x.IgnitionOn == null) && x.IsReportingDelay == true));
        }
        let gensetFilterData = uniq(gensetData); 
		
        if(gensetFilterData.length>0)
            ReeferCallout.BindClusterMapPushpins(gensetFilterData, 'genset', self.state.reeferFormatter);

        this.setState({
            rowData: gensetFilterData
        }, () => $('#globalLoader').hide());
        
        if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != []) {
            self.state.gridApiParams.paginationGoToFirstPage();
        }
        
    }

    onGridScroll(params: any) {
        $(".gensetcontext-menu").hide();
        $("#gensetcontextmenu").hide();
    }

    getMainMenuItems(params) {
        let finalMenuItem = [];
        let itemsToExclude = "resetColumns";
        params.defaultItems.forEach(function(item) {
            if (itemsToExclude.indexOf(item) < 0) {
                finalMenuItem.push(item);
            }
        });
        finalMenuItem.push({
            name: 'Reset Columns',
            action: function() {
                self.setState({ gridApiParams: params.api });
                var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                GridColumnPreferences.ResetGridColumns(functionId, params.api, "GensetStatusGrid");
            },
        });
        return finalMenuItem;
    }

    onColumnResized = (params: any) => {
        console.log("column resized..");
        self.onSaveGridRowGroupState(params);
    }

    public render() {
        var groupRowRendererParams: any = {
            innerRenderer: this.groupRowInnerRenderer
        };
        var excelStyles: any = [
            {
                id: 'bigInt',
                dataType: 'string',
                font: {
                    size: 12
                },

            },
            {
                id: 'myExcelStyle',
                font: {
                    size: 12,
                }
            },
            {
                id: 'header',
                font: {
                    size: 14,
                },
            },
        ];
        return <div>
            <div className='dashboard-GridToolbar'>               
                <GridGensetStatusToolBar
                    refreshGrid={this.refreshStatusGrid.bind(this)}
                    gridData={this.state.rowData}
                    colDefs={this.state.columnDefs}
                    colDefs2={columnDefs2}
                    gridApiParams={this.state.gridApiParams}
                    parentchild={"C"}
                    formName={"GensetStatusGrid"}
                    sourceFrom='Dashboard'
                    sensorData={gensetAssetSensors}
                    dashboardPreferenceId = {this.props.dashboardPreferenceId}
                    isReadOnly={this.props.isReadOnly}
                    revisionNum={this.props.revisionNum}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    validateRevisionNum={this.props.validateRevisionNum.bind(this)}
                    renderGridPreferenceDialog={this.renderGridPreferenceDialog.bind(this)}
                    renderEmailDialog={this.renderEmailDialog.bind(this)}
                    renderExportToExcelDialog={this.renderExportToExcelDialog.bind(this)} />
                <div className='aggrid-icons'>
                    <button type="button" className="btn btn-outline-secondary clearselectionBtn"
                        //onClick={this.ClearSelection.bind(this)}
                        onClick={this.props.renderClearSelection.bind(this)}
                        title='Clear Selection'><span className='fa-regular fa-eraser'></span> </button>
                </div>
                <div className='dashboard-filters'>
                    <GensetToggleButtonsFilter gridData={this.props.propsGensetData} filterGensetStatusGrid={this.filterGensetStatusGrid.bind(this)}></GensetToggleButtonsFilter>
                </div>
            </div>
            <div className="ag-theme-fresh Dashboard-Grid-height test " id='Grid-AlignGenset'>
                <AgGridReact
                    columnDefs={this.state.columnDefs}
                    rowData={this.state.rowData}
                    onGridReady={this.onGridReady}
                    animateRows={true}
                    rowGroupPanelShow={this.state.rowGroupPanelShow}
                    autoGroupColumnDef={this.state.autoGroupColumnDef}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    //groupRowInnerRenderer={this.groupRowInnerRenderer}
                    groupRowRendererParams={groupRowRendererParams}
                    onColumnRowGroupChanged={this.onSaveGridRowGroupState.bind(this)}
                    onDragStopped={this.onSavecolumnorder.bind(this)}
                    onSortChanged={this.onSort.bind(this)}
                    onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                    onColumnPinned={this.onSaveGridRowGroupState.bind(this)}
                    onColumnResized={Formatters.debounce(this.onColumnResized, 1000)}
                    getMainMenuItems={this.getMainMenuItems.bind(this)}
                    processCellForClipboard={this.ProcessCellForClipboard}
                    groupDisplayType='groupRows'
                    enableRangeSelection={true}
                    defaultGroupOrderComparator={
                        function (nodeA, nodeB) {
                            var AnodeIsNumber = Number(nodeA.key);
                            var BnodeIsNumber = Number(nodeB.key);
                            var AnodeIsString = String(nodeA.key);
                            var BnodeIsString = String(nodeB.key);

                            if (!isNaN(AnodeIsNumber) && !isNaN(BnodeIsNumber)) {
                                return AnodeIsNumber - BnodeIsNumber;
                            } else {
                                return AnodeIsString.localeCompare(BnodeIsString);
                            }
                        }
                    }
                    pagination={true}
                    rowSelection={'multiple'}
                    accentedSort={true}
                    rowDeselection={true}
                    onRowDataChanged={this.onRowDataChanged}
                    excelStyles={excelStyles}
                    onSelectionChanged={this.onGridSelectionChanged}
                    allowContextMenuWithControlKey={true}
                    getContextMenuItems={this.getGensetContextMenuItems}
                    paginationPageSize={this.state.pageSize}
                    onPaginationChanged={this.onGridPaginationChanged}
                    overlayLoadingTemplate={this.state.overlayLoadingTemplate}
                    onBodyScroll={this.onGridScroll}>
                </AgGridReact>
            </div>
            <div className='pageSize'>
                <span className='pageSize-lable'>Page Size:</span>
                <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                </select>
            </div>
            <div className='row' id="gensetcontextmenu">
                <button id="btnTriggerGenset" className='btnContext' onClick={this.props.onOpenCommandWindow} />
                <button id="btnTriggerPopupGenset" data-bs-toggle="modal" className='hidden' data-bs-target="#contextMenuModel" />
            </div>
        </div>;
    }
}

class ReeferHistorySearch {
    FromDate: string;
    ToDate: string;
    Units: string;
}

//WI-23853
enum ReeferAndDryAndChassisStatusEnum {
    AllReefer = 0,
    Running = 1,
    Stopped = 2,
    MissedRunning = 3,
    MissedStopped = 4,
    AllMicroAlaram = 5,
    MASevere = 6,
    MAMinor = 7,
    AllCargoCare = 8,
    CCSevere = 9,
    CCMinor = 10,
    CCInformational = 11,

    DryInGeofence = 16,
    DryOutGeofence = 17,   
    ChassisPwrInGeofence = 18,
    ChassisPwrOutGeofence = 19,
    ChassisNotPwrInGeofence = 20,
    ChassisNotPwrOutGeofence = 21
}


